import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acciones-rapidas',
  templateUrl: './acciones-rapidas.component.html',
  styleUrls: ['./acciones-rapidas.component.scss']
})
export class AccionesRapidasComponent implements OnInit {

  constructor(

        private router: Router,
  ) { }

  ngOnInit(): void {
  }

}
